import React from 'react';
import "./filter.scss";
import Dropdown from '../../../common/dropdown-v2/dropdown';
import DropdownV4 from '../../../common/dropdown-v4/dropdown';

import SchoolApi from '../../../../apis/school'
import MasterDataApi from '../../../../apis/master-data'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import 'bootstrap/dist/css/bootstrap.css'
class FilterComponent extends React.Component {

    state = {
        showShadow: false,
        showFilters: false,
        disableGo: true,

        boardsDropdownItems: [],
        classDropdownItems: [],
        chapterDropDownItems: [],
        teachersDropDownItems: [],
        selectedBoard: "",
        selectedClass: "",
        selectedChapterKey: [],
        selectedTeachersId: [],
        eloDropdownItems: [],
        skillDropdownItems: [],
        disableClass: true,
        disableChapters: true

    }

    classSectionHash = {}
    conceptHash = {}
    eloHash = {}

    componentDidMount() {
        this.getClasses()

        if (this.props.delegate?.props?.delegate?.props?.location?.state?.homeworkFilterPayload?.from === "LEARNING_RESOURCES") {
            this.toggleFilters()

            let filterPayload = {
                ...this.props.delegate?.props.delegate.props.location.state.homeworkFilterPayload
            }
            console.log(filterPayload)
            let isFromPk = false

            if (this.props.delegate?.props?.delegate?.props?.location?.state?.homeworkFilterPayload?.from === 'LEARNING_RESOURCES' &&
                this.props.delegate?.props?.delegate?.props?.location?.state?.homeworkFilterPayload?.forWhat === 'PREVIOUS_KNOWLEDGE') {
                isFromPk = true
            }

            this.setState({ isFromPk })

            if (filterPayload) {
                this.onSelectDropDown({ value: filterPayload.selectedBoard }, "selectedBoard")
                this.onSelectDropDown({ value: filterPayload.selectedClass }, "selectedClass")

                setTimeout(() => {
                    this.onSelectDropDown({ title: filterPayload.chapterTitle, value: filterPayload.chapterKey }, "selectedChapter")
                }, 500)

                setTimeout(() => {
                    this.onMultiSelectDropdown([{ title: filterPayload.selectedConceptName, value: filterPayload.conceptKey, order: 1 }], "selectedConcept")
                    this.onClickGo()
                }, 800)


            }

        }
    };

    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                if (boards.length > 1) {
                    this.setState({ boardsDropdownItems: boards })
                } else {
                    this.setState({ selectedBoard: school?.boards[0]?.name })
                }
                this.setState({ classDropdownItems: classes, })
            }).catch(err => {
            })
    }

    getSections(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = this.state.selectedBoard

        if (!payload.class || !payload.board) {
            this.setState({ sectionDropdownItems: [], selectedSection: "" })
            this.reloadDropdown()
            return
        }

        SchoolApi.getSections(payload)
            .then(response => {
                let sections = []
                for (let i = 0; i < response.response.length; i++) {
                    sections.push({
                        title: response.response[i].section,
                        value: response.response[i].section,
                    })
                }
                this.classSectionHash[payload.class] = sections
                this.setState({ sectionDropdownItems: sections, selectedSection: "" })
                this.reloadDropdown()
            }).catch(err => {
                this.setState({ sectionDropdownItems: [], selectedSection: "" })
                this.reloadDropdown()
            })
    }

    getChapters(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = this.state.selectedBoard

        MasterDataApi.getChapterList(payload)
            .then(response => {
                let chapters = []
                response = response.data
                this.setState({ masterDataId: response._id })
                for (let i = 0; i < response.chapters.length; i++) {
                    let chapter = response.chapters[i], concepts = []
                    chapters.push({
                        title: chapter.title,
                        value: chapter.key,
                    })

                    for (let j = 0; j < chapter.concepts?.length; j++) {
                        let concept = chapter.concepts[j]
                        concepts.push({
                            title: concept.title,
                            value: concept.key,
                            order: j + 1
                        })
                        // this.buildElosDropdown(concept)
                    }

                    this.conceptHash[chapter.key] = concepts
                }

                this.conceptAndChapterKeyHash = {}

                if (this.state.isFromPk) {

                    let hash = this.getChapterKeyForConceptKey()

                    // console.log(hash)


                    for (let i = 0; i < response.chapters.length; i++) {
                        let chapter = response.chapters[i]
                        this.conceptHash[this.getChapterKeyForPk()].forEach(concept => {

                            concept.baseChapterKey = hash[concept.value]

                            // if (concept.title === chapter.title) {
                            //     // Origion Chapter Key
                            //     this.conceptAndChapterKeyHash[concept.value] = chapter.key
                            // }

                        })
                    }
                }

                console.log(this.conceptHash)

                // chapters.push({value:'ALL',title:'ALL'})
                this.setState({ chapterDropDownItems: chapters, })
                this.reloadDropdown()
            }).catch(err => {
                this.setState({ chapterDropDownItems: [] })
                this.reloadDropdown()
            })
    }

    getChapterKeyForConceptKey() {

        let hash = {}

        switch (this.state.selectedClass) {
            case 'Class 6':
                hash = {
                    "16533837374847142": "15845131996920700",
                    "16533858012107294": "15856473964482771",
                    "16533859537866169": "15857164729919834",
                    "16533860794669673": "15857164976853655",
                    "16533862257725123": "15857165495906003",
                    "16533863628124282": "15857165661650098",
                    "16533867311374147": "15857165848090445",
                    "16533868102843285": "15857166094719563",
                    "16533868829612973": "15857166437420553",
                    "16533869787154165": "15857166644378707"
                };
                break;
            case 'Class 7':
                hash = {
                    "16533871621566975": "15845144070966249",
                    "16533881394545621": "15856360518110730",
                    "16533883752772603": "15856361122223503",
                    "16533885081008251": "15856361208264022",
                    "16533886374021934": "15856361345562753",
                    "16533887891449037": "15856361596729330",
                    "16533895225638602": "15856361627495437",
                    "16533902524652201": "15856361652486357",
                    "16533907111994765": "15856361747031712",
                    "16533909564324035": "15856361811697076",
                    "16533914238938593": "15856362701104974",
                    "16533915422089716": "15856362826362665",
                    "16533916030612908": "15856363000898741",
                    "16533916081672939": "15856363107929523"
                };
                break;
            case 'Class 8':
                hash = {
                    "16533928739794336": "15857337683614007",
                    "16533934346894248": "15868832020204343",
                    "16533935529353288": "15873071841353333",
                    "16533939949709566": "15873072185461315",
                    "16533950094755221": "15873072390168173",
                    "16533962077391457": "15873072479404585",
                    "16533975927102829": "15873072632957093",
                    "16533977231750042": "15873072719086513",
                    "16533979369062274": "15873072822706766",
                    "16533982570657139": "15873073030008444"
                };
                break;
            case 'Class 9':
                hash = {
                    "16534518035374484": "16252167032887549",
                    "16534518235596193": "16255594624435369",
                    "16534518732721148": "16255595864935652",
                    "16534518933521005": "16255596084001110",
                    "16534518940551071": "16255596226781160",
                    "16534519476447793": "16255597711777661",
                    "16534519779433487": "16255597874627555"
                };
                break;
            default:
                hash = {
                    "16533837374847142": "15845131996920700",
                    "16533858012107294": "15856473964482771",
                    "16533859537866169": "15857164729919834",
                    "16533860794669673": "15857164976853655",
                    "16533862257725123": "15857165495906003",
                    "16533863628124282": "15857165661650098",
                    "16533867311374147": "15857165848090445",
                    "16533868102843285": "15857166094719563",
                    "16533868829612973": "15857166437420553",
                    "16533869787154165": "15857166644378707"
                }
                break;
        }

        return hash

    }

    sortPayload(nodes) {
        let orderedList = [];
        let workFlowNodeHash = {};
        let startingNode;

        for (let i = 0; i < nodes.length; i++) {

            let nodeId = nodes[i]._id.toString();

            if (nodes[i].previousNode == null)
                startingNode = nodeId;

            workFlowNodeHash[nodeId] = nodes[i];
        }

        let tempNode = startingNode;

        for (let i = 0; i < nodes.length; i++) {
            if (tempNode) {
                orderedList.push(workFlowNodeHash[tempNode]);
                tempNode = workFlowNodeHash[tempNode].nextNode;
            }
        }
        return orderedList
    }

    getChapterKeyForPk() {

        let chapterKey = ''

        switch (this.state.selectedClass) {
            case 'Class 6':
                chapterKey = '16533836874781844';
                break;
            case 'Class 7':
                chapterKey = "16533871579715896";
                break;
            case 'Class 8':
                chapterKey = "16533917931207385";
                break;
            case 'Class 9':
                chapterKey = "16534517911704106";
                break;
            default:
                chapterKey = '16533836874781844';
                break;

        }

        return chapterKey
    }


    getWorkflowNodes(payload = {}) {
        payload = {
            class: this.state.selectedClass,
            board: this.state.selectedBoard,
            chapterKey: this.state.selectedChapter,
            masterDataId: this.state.masterDataId
        }

        if (this.state.isFromPk) {
            payload.chapterKey = this.getChapterKeyForPk()
        }

        MasterDataApi.getWorkflowNodes(payload)
            .then(response => {
                response = response.data
                this.eloHash = {}
                for (let i = 0; i < response.length; i++) {
                    let chapter = response[i], elos = []

                    for (let j = 0; j < chapter.elos?.length; j++) {
                        let elo = chapter.elos[j]
                        elos.push({
                            title: elo.title,
                            value: elo.id,
                            conceptTitle: chapter.conceptTitle,
                            conceptValue: chapter.conceptKey,
                            skill: elo.skill?.title
                        })
                    }
                    if (this.eloHash[chapter.conceptKey]) {
                        this.eloHash[chapter.conceptKey].push(...elos)
                    } else {
                        this.eloHash[chapter.conceptKey] = elos
                    }
                }

                let eloList = this.sortPayload(response)
                this.setState({ orderedEloList: eloList })
            }).catch(err => {
            })
    }

    buildElosDropdown(concept) {
        let elos = []
        for (let i = 0; i < concept?.subConcepts?.length; i++) {
            let subConcept = concept.subConcepts[i]
            for (let j = 0; j < subConcept.elo?.length; j++) {
                let elo = subConcept.elo[j]
                elos.push({
                    title: elo.title,
                    value: elo.eloId,
                    conceptTitle: concept.title,
                    conceptValue: concept.key,
                })
            }

        }
        this.eloHash[concept.key] = elos
        return
    }

    reloadDropdown() {
        this.setState({ reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })
    }

    resetDropDowns(callback) {
        this.setState({
            selectedBoardId: "",
            selectedClassId: "",
            chapterDropdownItems: [],
        }, () => { if (callback) callback(); });
    }


    onGo() {
        let payload = {
            board: this.state.selectedBoard,
            class: this.state.selectedClass,
            chapterKey: this.state.selectedChapterKey,
            assignedTo: this.state.selectedTeachersId
        };
        if (this.props.onGo) {
            this.props.onGo(payload)
        }
    }

    refreshPage() {
        this.setState(
            { reload: true },
            () => this.setState({ reload: false })
        )
    }

    toggleFilters = () => {
        this.setState({ showFilters: !this.state.showFilters })
    }

    onSelectDropDown = (option, key) => {
        this.setState({ [key]: option?.value, [`${key}Object`]: option }, () => {
            if (key == "selectedClass" || key == "selectedBoard") {
                this.getSections()
                this.getChapters()
            }

            if (key == "selectedChapter") {
                if (option?.value) {
                    this.getWorkflowNodes()

                    if (this.state.isFromPk) {
                        let chapterKey = this.props.delegate?.props?.delegate?.props?.location?.state?.homeworkFilterPayload?.chapterKey ? this.props.delegate?.props?.delegate?.props?.location?.state?.homeworkFilterPayload?.chapterKey : ''
                        console.log(chapterKey)
                        let concept = this.conceptHash[this.getChapterKeyForPk()].filter(item => item.baseChapterKey === chapterKey)
                        console.log(concept)
                        this.setState({ conceptDropownItems: concept, pkConceptKey: concept[0]?.value ? concept[0].value : '', reloadConceptDropdown: true }, () => {
                            this.setState({ reloadConceptDropdown: false })

                        })
                    } else {
                        let concepts = this.conceptHash[option?.value]
                        // concepts.push({title:'ALL',value:'ALL'})
                        this.setState({ conceptDropownItems: concepts, reloadConceptDropdown: true, selectedConcept: "" }, () => {
                            this.setState({ reloadConceptDropdown: false })
                        })
                    }


                } else {

                    this.setState({ conceptDropownItems: [], reloadConceptDropdown: true, selectedConcept: "" }, () => {
                        this.setState({ reloadConceptDropdown: false })
                    })
                }
                this.reloadDropdown()
            }

        })
    }

    onMultiSelectDropdown = (options, key) => {
        let value = [], eloDropdownItems = [], skillDropdownItems = [], skillHash = {}

        if (this.state.isFromPk) {
            options = [{ value: this.state.pkConceptKey, order: 1 }]
        }
        options = options.sort((a, b) => a.order - b.order)
        for (let i = 0; i < options.length; i++) {
            let option = options[i]
            value.push(option?.value)

            if (key == "selectedConcept") {
                if (this.eloHash[option?.value]) {

                    let elo = this.eloHash[option?.value]
                    let elos = elo.map((e) => {

                        if (!skillHash[e.skill]) {
                            skillHash[e.skill] = true
                            skillDropdownItems.push({ title: e.skill, value: e.skill })
                        }
                        return {
                            ...e,
                            conceptName: `Concept ${i + 1}`
                        }
                    })
                    eloDropdownItems.push(...elos)
                }
                this.setState({ selectedElo: "" })
            }
        }
        this.setState({ reloadDropdown: true, reloadConceptDropdown: true, eloDropdownItems, skillDropdownItems, [key]: value, [`${key}Object`]: options }, () => {
            this.setState({ reloadDropdown: false, reloadConceptDropdown: false })
        })
    }


    onSelectElo = (options) => {
        let values = options.map(option => option?.value)
        let result = []
        for (let i = 0; i < this.state.orderedEloList?.length; i++) {
            let eloId = this.state.orderedEloList[i]?.elos[0]?.id
            if (values.includes(eloId)) {
                result.push(eloId)
            }
        }

        this.setState({ selectedElo: result, selectedEloObject: options }, () => {
        })
    }

    handleCreatedDateEvent = (event, picker) => {
        // this.createdStartDate = new Date(picker.startDate);
        // this.createdEndDate = new Date(picker.endDate);

        this.createdDateRangeStart = new Date(picker.startDate);
        this.createdDateRangeEnd = new Date(picker.endDate).toLocaleDateString() == new Date().toLocaleDateString() ? new Date() : new Date(picker.endDate);

        this.setState({ createdDate: this.createdDateRangeStart.toLocaleDateString(), selectedCreatedDateRange: this.createdDateRangeStart.toLocaleDateString() + "  -  " + this.createdDateRangeEnd.toLocaleDateString() });
    }

    handleDueDateEvent = (event, picker) => {
        this.dueDateRangeStart = new Date(picker.startDate);
        this.dueDateRangeEnd = new Date(picker.endDate).toLocaleDateString() == new Date().toLocaleDateString() ? (new Date(new Date().setHours(23, 59, 59, 999)).toISOString()).slice(0, -1) : (new Date(new Date(picker.endDate).setHours(23, 59, 59, 999)).toISOString()).slice(0, -1);

        this.setState({ dueDate: new Date(this.dueDateRangeStart).toLocaleDateString(), selectedDueDateRange: new Date(this.dueDateRangeStart).toLocaleDateString() + "  -  " + new Date(this.dueDateRangeEnd).toLocaleDateString() });
    }


    onClickGo = () => {

        let payload = {
            board: this.state.selectedBoard,
            class: this.state.selectedClass,
            section: this.state.selectedSection,
            sectionObject: this.state.selectedSectionObject,
            chapter: this.state.selectedChapter,
            chapterObject: this.state.selectedChapterObject,
            concepts: this.state.selectedConcept,
            conceptsObject: this.state.selectedConceptObject,
            elos: this.state.selectedElo,
            eloObject: this.state.selectedEloObject,
            dueDateRangeStart: this.dueDateRangeStart,
            createdDateRangeStart: this.createdDateRangeStart,
            dueDateRangeEnd: this.dueDateRangeEnd ? (new Date(new Date(this.dueDateRangeEnd).setHours(23, 59, 59, 999)).toISOString()).slice(0, -1) : '',
            createdDateFilter: this.state.selectedCreatedDateRange,
            dueDateFilter: this.state.selectedDueDateRange,
            createdDateRangeEnd: this.createdDateRangeEnd,
        }

        console.log(payload)

        if (this.props.delegate.onFilterGo) {
            this.props.delegate.onFilterGo(payload)
        }
    }

    clearFilter = () => {
        this.setState({ selectedBoard: "", selectedClass: "", selectedSection: "", selectedChapter: "", selectedConcept: "", selectedElo: "", dueDate: '', createdDate: "", selectedCreatedDateRange: '', selectedDueDateRange: '', conceptDropownItems: [], chapterDropDownItems: [], eloDropdownItems: [], sectionDropdownItems: [] }, () => {
            this.dueDate = ""
            this.createdDate = ""
            this.createdDateRangeStart = ''
            this.createdDateRangeEnd = ''
            this.dueDateRangeStart = ''
            this.dueDateRangeEnd = ''
            this.refreshPage()
            if (this.props.delegate.onFilterGo) {
                this.props.delegate.onFilterGo()
            }
        })

    }


    render() {

        return (

            <div className="new-homwwork-filter">
                <div className="filter-header" >
                    <div className="d-inline" onClick={this.toggleFilters}>
                        <div className="filter-title d-inline">{"Filters"}</div>
                        <div className="d-inline"><i class={this.state.showFilters ? "filter-arrow up" : "filter-arrow down"}></i></div>
                    </div>
                </div>
                {
                    !this.state.reload ?
                        <div className={this.state.showFilters ? "filter-content" : "filter-content d-none"} >
                            <div className="row">
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Created Date
                                    </div>
                                    <div>
                                        <DateRangePicker onHide={this.handleCreatedDateEvent} onCancel={() => { }}
                                            autoApply
                                            maxDate={new Date().toLocaleDateString()}
                                            initialSettings={{ singleDatePicker: false, startDate: this.createdDatesRangeStart, endDate: this.createdDateRangeEnd, autoUpdateInput: false }}
                                            locale={{
                                                'format': 'DD/MM/YYYY'
                                            }}
                                            // maxDate={new Date().toLocaleDateString()}
                                        ><input className="cw-input bg-white" placeholder="Select date" value={this.state.selectedCreatedDateRange}></input>
                                        </DateRangePicker>


                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Due Date
                                    </div>
                                    <div>
                                        <DateRangePicker onHide={this.handleDueDateEvent} onCancel={() => { }}
                                            autoApply
                                            maxDate={new Date().toLocaleDateString()}
                                            initialSettings={{ singleDatePicker: false, startDate: this.dueDatesRangeStart, endDate: this.dueDateRangeEnd, autoUpdateInput: false }}
                                            locale={{
                                                'format': 'DD/MM/YYYY'
                                            }}
                                            // maxDate={new Date().toLocaleDateString()}
                                        ><input className="cw-input bg-white" placeholder="Select date" value={this.state.selectedDueDateRange}></input>
                                        </DateRangePicker>
                                    </div>
                                </div>
                                {
                                    this.state.boardsDropdownItems.length > 1 ?
                                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                            <div className="filter-input-label">
                                                Board
                                            </div>
                                            <div>
                                                {
                                                    !this.state.reloadDropdown ?
                                                        <Dropdown
                                                            placeholder='Select a board'
                                                            options={this.state.boardsDropdownItems}
                                                            onSelect={(option) => this.onSelectDropDown(option, "selectedBoard")}
                                                            text={"title"}
                                                            value={this.state.selectedBoard}

                                                        />
                                                        : ''
                                                }

                                            </div>
                                        </div>
                                        : ""
                                }
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Class
                                    </div>
                                    <div>
                                        {
                                            !this.state.reloadDropdown ?
                                                <Dropdown
                                                    placeholder='Select a Class'
                                                    options={this.state.classDropdownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedClass")}
                                                    text={"title"}
                                                    value={this.state.selectedClass}

                                                /> : ""
                                        }

                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Section
                                    </div>
                                    <div>
                                        {
                                            !this.state.reloadDropdown ?
                                                <Dropdown
                                                    key="class"
                                                    multiSelect
                                                    placeholder='Select a Section'
                                                    options={this.state.sectionDropdownItems}
                                                    onSelect={(option) => this.onMultiSelectDropdown(option, "selectedSection")}
                                                    text={"title"}
                                                    value={this.state.selectedSection}
                                                >
                                                </Dropdown>
                                                : ""
                                        }
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Chapter
                                    </div>
                                    <div>
                                        {
                                            !this.state.reloadDropdown ?
                                                <Dropdown
                                                    placeholder='Select Chapter'
                                                    options={this.state.chapterDropDownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedChapter")}
                                                    text={"title"}
                                                    value={this.state.selectedChapter}
                                                    disabled={this.props.delegate?.props?.delegate?.props?.location?.state?.homeworkFilterPayload?.forWhat === 'PREVIOUS_KNOWLEDGE'}
                                                >
                                                </Dropdown>
                                                : ''
                                        }


                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Concept
                                    </div>
                                    <div>
                                        {
                                            !this.state.reloadConceptDropdown ?
                                                <DropdownV4
                                                    placeholder='Select a Concept'
                                                    options={this.state.conceptDropownItems}
                                                    onSelect={(option) => this.onMultiSelectDropdown(option, 'selectedConcept')}
                                                    text={"title"}
                                                    multiSelect
                                                    value={this.state.selectedConcept}
                                                /> : ""
                                        }
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Learning Outcome
                                    </div>
                                    <div>
                                        {
                                            !this.state.reloadDropdown ?
                                                <DropdownV4
                                                    key="learning"
                                                    placeholder='Select learning outcomes'
                                                    options={this.state.eloDropdownItems}
                                                    onSelect={(option) => this.onSelectElo(option)}
                                                    value={this.state.selectedElo}
                                                    text={"title"}
                                                    multiSelect
                                                    isGroup
                                                    groupKey="conceptValue"
                                                    groupTitle="conceptTitle"
                                                    groupName="conceptName"
                                                    isLocalSearch
                                                />

                                                : ""
                                        }
                                    </div>
                                </div>
                                <div className="row col-lg-3 col-md-6 col-sm-12 pt-4 ml-2">
                                    <div className="filter-button  d-inline-block">
                                        <button className={`cw-button`} onClick={this.onClickGo.bind(this)}>{"GO"}</button>
                                    </div>
                                    <div className="filter-button ml-3 d-inline-block">
                                        <button className={`cw-button clear-btn`} onClick={this.clearFilter.bind(this)}>{"CLEAR"}</button>
                                    </div>
                                </div>
                            </div>
                        </div> : ""

                }
            </div>


        );
    }

}

export default FilterComponent;